import React, {useContext} from 'react';
import UserContext from '../common/UserContext.js';

// components
import Survey from './Survey.js';
import ThankYouSurvey from './ThankYouSurvey.js';

function Surveys() {
    const { surveyState } = useContext(UserContext);

    if (!surveyState?.visible) return null;

    if (surveyState?.step === 'thank_you') {
        return <ThankYouSurvey />;
    }

    return <Survey/>;
}

export default Surveys;